<template>
    <OpportunityPageDetailTopLayout org-layout>
        <template #image>
            <CThumbnailImage
                :alt="org.title"
                class="text-gray-750 dark:text-txt-headings"
                :src="isOrgFieldVisible(org, 'image') ? org.image : ''"
                type="org"
            />
        </template>

        <template #highlights>
            <CHeading class="mb-4">
                {{ org.title }}
            </CHeading>

            <OrgHighlights :org="org" />

            <component
                :is="preview ? CTags : CSearchTags"
                v-if="org.interests && org.interests.length && isOrgFieldVisible(org, 'interests')"
                class="mt-3 sm:mt-8"
                query-search-param="hashtag"
                search-route-name="organizacie"
                :tags="getOrgFieldFunction(org, 'interests')(org.interests)"
            />
        </template>

        <template #bottom>
            <OrgOpportunitiesCount :jobs="jobs" :org-id="org.id" :projects="projects" :skills="skills" />
        </template>
    </OpportunityPageDetailTopLayout>
</template>

<script setup lang="ts">
import type { Job } from '#shared/types/Job'
import type { Org } from '#shared/types/Org'
import type { Project } from '#shared/types/Project'
import type { Skill } from '#shared/types/Skill'
import OpportunityPageDetailTopLayout from '@/components/common/opportunity/OpportunityPageDetailTopLayout.vue'
import OrgHighlights from '@/components/orgs/OrgHighlights.vue'
import OrgOpportunitiesCount from '@/components/orgs/OrgOpportunitiesCount.vue'
import CHeading from '@/components/ui/CHeading.vue'
import CSearchTags from '@/components/ui/CSearchTags.vue'
import CTags from '@/components/ui/CTags.vue'
import CThumbnailImage from '@/components/ui/CThumbnailImage.vue'
import { useOrgs } from '@/composables/orgs/useOrgs'

const props = withDefaults(defineProps<{
    org: Org
    skills?: Skill[]
    projects?: Project[]
    jobs?: Job[]
    preview?: boolean
}>(), {
    skills: () => [],
    projects: () => [],
    jobs: () => [],
    preview: false
})

const { isOrgFieldVisible, getOrgFieldFunction } = useOrgs()
</script>